import { ReactNode } from 'react';

import './bizos-button.styles.scss';

export type BizosButtonProps = {
    color?: 'primary' | 'secondary';
    children: ReactNode;
    onClick?:() => void;
};

const BizosButton = ({ color = 'primary',onClick, children }: BizosButtonProps) => {
    const handleClick = () => onClick && onClick();
  return <button className={`bizos-button bizos-button--${color}`} onClick={handleClick}>{children}</button>;
}

export default BizosButton;
